import { MODES, type Mode } from '@theory/modes';
import { displayModeName } from '@util/displayMode';
import { useAppStore } from '@app/store/useAppStore';
import shared from './dropdownShared.module.css';

export function ModeDropdown() {
  const mode = useAppStore((s) => s.selectedMode);
  const setMode = useAppStore((s) => s.setMode);
  const useTraditionalNames = useAppStore((s) => s.useTraditionalNames);

  return (
    <select
      className={shared.select}
      value={mode}
      onChange={(e) => setMode(e.target.value as Mode)}
      aria-label="Mode"
    >
      {MODES.map((m) => (
        <option key={m} value={m}>
          {displayModeName(m, useTraditionalNames)}
        </option>
      ))}
    </select>
  );
}
